import { Button, themeStore } from "@root/common"
import { observer } from "mobx-react-lite"
import React, { FC } from "react"
import { OrdersMode } from "../../api/orders.api"


export interface ChooseModeFormProps {
  onChange: (mode: OrdersMode) => void
}

export const ChooseModeForm: FC<ChooseModeFormProps> = observer(({onChange}) => {

  const buttonStyle: React.CSSProperties = {
    width: '100%',
    backgroundColor: themeStore.bgColor,
    color: themeStore.textColor,
    border: `1px solid ${themeStore.textColor}`
  }

  return (
    <>
      <b>Выбор режима</b>
      <Button style={buttonStyle} onClick={() => {onChange(OrdersMode.LIMIT)}}>Лимитные ордера</Button>
      <Button style={buttonStyle} onClick={() => {onChange(OrdersMode.MARKET)}}>Маркет ордера</Button>
      <Button style={buttonStyle} onClick={() => {onChange(OrdersMode.FAST)}}>Быстрое открытие</Button>
      <br/>
    </>
  )
})
